import axios from "axios";
import { appConfig } from "../config/config";
import CookieService from "./CookieService";

const baseApiClient = axios.create({
  baseURL: appConfig.baseBackendUrl,
  withCredentials: true,
});

const authApiClient = baseApiClient;

authApiClient.interceptors.request.use(
  async (config: any) => {
    const accessToken = CookieService.getCookie(appConfig.authAccessToken);
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

authApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      CookieService.removeCookie(appConfig.authAccessToken);

      window.location.href = "/auth";
    }
    return Promise.reject(error);
  }
);

export { authApiClient, baseApiClient };
